module.exports = __webpack_public_path__ + "img/UAJY.ba0b7f07.png";